import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../../../shared/shared.module";
import { Widget, WidgetType } from "../../models/dashboard.model";
import { WidgetDataFacadeService } from "../../services/widget-data-facade.service";
import { TypeControle } from "../../../controle/enums/type-controle";
import { WidgetProductiviteMoyenneComponent } from "../../components/widget-productivite-moyenne/widget-productivite-moyenne.component";
import { WidgetOfEnCoursComponent } from "../../components/widget-of-en-cours/widget-of-en-cours.component";
import { WidgetHeuresTravaillesComponent } from "../../components/widget-heures-travailles/widget-heures-travailles.component";
import { WidgetQuantiteOfComponent } from "../../components/widget-quantite-of/widget-quantite-of.component";
import { WidgetCaCumuleComponent } from "../../components/widget-ca-cumule/widget-ca-cumule.component";
import { WidgetRepartitionParClientComponent } from "../../components/widget-repartition-par-client/widget-repartition-par-client.component";
import { WidgetCaParPeriodeComponent } from "../../components/widget-ca-par-periode/widget-ca-par-periode.component";
import { WidgetCaNMoinsComponent } from "../../components/widget-ca-nmoins/widget-ca-nmoins.component";
import { WidgetLotParEtatComponent } from "../../components/widget-lot-par-etat/widget-lot-par-etat.component";
import { WidgetValeurParFamilleComponent } from "../../components/widget-valeur-par-famille/widget-valeur-par-famille.component";
import { WidgetCommandeFournisseurListComponent } from "../../components/widget-commande-fournisseur-list/widget-commande-fournisseur-list.component";
import { WidgetCommandeClientListComponent } from "../../components/widget-commande-client-list/widget-commande-client-list.component";
import { WidgetCaDeltaComponent } from "../../components/widget-ca-delta/widget-ca-delta.component";
import { WidgetOfListComponent } from "../../components/widget-of-list/widget-of-list.component";
import { WidgetSpecificationListComponent } from "../../components/widget-specification-list/widget-specification-list.component";
import { QuickWinScatterComponent } from "../../../articles/components/quick-wins-dashboard/quick-win-scatter.component";
import { ConsosParArticleComponent } from "../../../articles/components/consos-par-article/consos-par-article.component";
import { OfProductionsTableComponent } from "../../../articles/components/of-productions-table/of-productions-table.component";
import { AchatsParFournisseurComponent } from "../../../articles/components/achats-par-fournisseur/achats-par-fournisseur.component";
import { AchatPrixEvolutionComponent } from "../../../articles/components/stats-article-achat-evolution/stats-article-achat-evolution.component";
import { MargeParTiersComponent } from "../../../articles/components/marge-par-tiers/marge-par-tiers.component";
import { WidgetCaCumuleArticleComponent } from "../../../articles/components/ca-cumule-article/ca-cumule-article.component";
import { CaParPeriodeArticleComponent } from "../../../articles/components/ca-par-periode-article/ca-par-periode-article.component";
import { MouvementsSyntheseComponent } from "../../../articles/components/mouvements-synthese/mouvements-synthese.component";
import { StockKpisComponent } from "../../../articles/components/stocks-kpi/stocks-kpi.component";
import { HeuresParUserComponent } from "../../../articles/components/heures-par-user/heures-par-user.component";
import { RepartitionCaTiersComponent } from "../../../tiers/components/repartition-ca-tiers/repartition-ca-tiers.component";
import { WidgetCaCumuleTiersComponent } from "../../../tiers/components/ca-cumule-article/ca-cumule-tiers.component";
import { CaParPeriodeTiersComponent } from "../../../tiers/components/ca-par-periode-article/ca-par-periode-tiers.component";
import { StatsAchatEvolutionByArticleComponent } from "../../../tiers/components/stats-article-achat-evolution-tiers/stats-article-achat-evolution-tiers.component";
import { StatsVenteEvolutionByArticleComponent } from "../../../tiers/components/stats-article-vente-evolution-tiers/stats-article-vente-evolution-tiers.component";
import { AchatsArticlesParTiersComponent } from "../../../tiers/components/achat-articles-par-tiers/achat-articles-par-tiers.component";
import { VentesParClientComponent } from "../../../articles/components/vente-par-client/vente-par-client.component";
import { RepartitionCaArticleComponent } from "../../../articles/components/repartition-ca-article/repartition-ca-article.component";
import { WidgetQuantiteProduitePeriodeComponent } from "../../components/widget-quantite-produite-periode/widget-quantite-produite-periode.component";
import { WidgetQuantiteProduiteLigneComponent } from "../../components/widget-quantite-produite-ligne/widget-quantite-produite-ligne.component";
import { WidgetMainOeuvreLigneComponent } from "../../components/widget-main-oeuvre-ligne/widget-main-oeuvre-ligne.component";
import { WidgetProductiviteLigneComponent } from "../../components/widget-productivite-ligne/widget-productivite-ligne.component";
import { WidgetCoutsLigneComponent } from "../../components/widget-couts-ligne/widget-couts-ligne.component";
import { WidgetOfsLigneComponent } from "../../components/widget-ofs-ligne/widget-ofs-ligne.component";
import { WidgetArticlesProduitsLigneComponent } from "../../components/widget-articles-produits-ligne/widget-articles-produits-ligne.component";
import { WidgetHeuresUserInfosComponent } from "../../components/widget-heures-user-infos/widget-heures-user-infos.component";
import { WidgetRepartitionTravailUserInfosComponent } from "../../components/widget-repartition-travail-user-infos/widget-repartition-travail-user-infos.component";
import { WidgetOfsUserInfosComponent } from "../../components/widget-ofs-user-infos/widget-ofs-user-infos.component";
import { WidgetProductiviteUserInfosComponent } from "../../components/widget-productivite-user-infos/widget-productivite-user-infos.component";
import { WidgetLignesUserInfosComponent } from "../../components/widget-lignes-user-infos/widget-lignes-user-infos.component";
import { WidgetArticlesProduitsUserInfosComponent } from "../../components/widget-articles-produits-user-infos/widget-articles-produits-user-infos.component";
import { WidgetPlanningComponent } from "../../components/widget-planning/widget-planning.component";
import { WidgetNcStatsComponent } from "../../components/widget-nc-stats/widget-nc-stats.component";
import { WidgetNcClosureMetricsComponent } from "../../components/widget-nc-closure-metrics/widget-nc-closure-metrics.component";
import { WidgetNcSupplierComplianceComponent } from "../../components/widget-nc-supplier-compliance/widget-nc-supplier-compliance.component";
import { WidgetEvolutionValeurComponent } from "../../components/widget-evolution-valeur/widget-evolution-valeur.component";
import { WidgetLiveProductionComponent } from "../../components/widget-live-production/widget-live-production.component";
import { WidgetCertificatBioEcheanceComponent } from "../../components/widget-certificat-bio-echeance/widget-certificat-bio-echeance.component";
import { WidgetCouvertureCommandesComponent } from "../../components/widget-couverture-commandes/widget-couverture-commandes.component";

@Component({
  selector: "vl-widget-container",
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    WidgetCaDeltaComponent,
    WidgetProductiviteMoyenneComponent,
    WidgetOfEnCoursComponent,
    WidgetHeuresTravaillesComponent,
    WidgetQuantiteOfComponent,
    WidgetCaCumuleComponent,
    WidgetRepartitionParClientComponent,
    WidgetCaParPeriodeComponent,
    WidgetCaNMoinsComponent,
    WidgetLotParEtatComponent,
    WidgetValeurParFamilleComponent,
    WidgetCommandeFournisseurListComponent,
    WidgetCommandeClientListComponent,
    WidgetOfListComponent,
    WidgetSpecificationListComponent,
    QuickWinScatterComponent,
    ConsosParArticleComponent,
    OfProductionsTableComponent,
    AchatsParFournisseurComponent,
    AchatPrixEvolutionComponent,
    VentesParClientComponent,
    MargeParTiersComponent,
    RepartitionCaArticleComponent,
    WidgetCaCumuleArticleComponent,
    CaParPeriodeArticleComponent,
    MouvementsSyntheseComponent,
    StockKpisComponent,
    HeuresParUserComponent,
    RepartitionCaTiersComponent,
    WidgetCaCumuleTiersComponent,
    CaParPeriodeTiersComponent,
    StatsAchatEvolutionByArticleComponent,
    StatsVenteEvolutionByArticleComponent,
    AchatsArticlesParTiersComponent,
    WidgetQuantiteProduitePeriodeComponent,
    WidgetQuantiteProduiteLigneComponent,
    WidgetMainOeuvreLigneComponent,
    WidgetProductiviteLigneComponent,
    WidgetCoutsLigneComponent,
    WidgetOfsLigneComponent,
    WidgetArticlesProduitsLigneComponent,
    WidgetHeuresUserInfosComponent,
    WidgetRepartitionTravailUserInfosComponent,
    WidgetOfsUserInfosComponent,
    WidgetProductiviteUserInfosComponent,
    WidgetLignesUserInfosComponent,
    WidgetArticlesProduitsUserInfosComponent,
    WidgetPlanningComponent,
    WidgetNcStatsComponent,
    WidgetNcClosureMetricsComponent,
    WidgetNcSupplierComplianceComponent,
    WidgetEvolutionValeurComponent,
    WidgetLiveProductionComponent,
    WidgetCertificatBioEcheanceComponent,
    WidgetCouvertureCommandesComponent,
  ],
  host: { class: "widget-component" },
  templateUrl: "./widget-container.component.html",
  styleUrl: "./widget-container.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetContainerComponent {
  facade = inject(WidgetDataFacadeService);

  customLoading = input<boolean>(false);
  editable = input<boolean>(false);
  widget = input<Widget>();
  widgetData = computed(() => {
    if (this.widget()?.type) {
      switch (this.widget()?.type) {
        case WidgetType.CA_CUMULE:
        case WidgetType.CA_PAR_PERIODE:
        case WidgetType.CA_DELTA:
        case WidgetType.CA_N_MOINS_1:
          return this.facade.getById(WidgetType.CA_CUMULE)();
        default:
          return this.facade.getById(this.widget()?.type)();
      }
    }
  });

  metaData = computed(() => {
    if (this.widget()?.type) {
      switch (this.widget()?.type) {
        case WidgetType.CA_CUMULE:
        case WidgetType.CA_PAR_PERIODE:
        case WidgetType.CA_DELTA:
        case WidgetType.CA_N_MOINS_1:
          return this.facade.getMetadata(WidgetType.CA_CUMULE);
        default:
          return this.facade.getMetadata(this.widget()?.type);
      }
    }
  });

  wType = WidgetType;

  constructor() {
    effect(() => {
      // Re-fetch déclenché à chaque "Actualiser" du dashboard via le tick.
      this.facade.refreshTick();
      if (!this.customLoading() && this.widget()?.type) {
        switch (this.widget()?.type) {
          case WidgetType.CA_CUMULE:
          case WidgetType.CA_PAR_PERIODE:
          case WidgetType.CA_DELTA:
          case WidgetType.CA_N_MOINS_1:
            this.facade.loadById(WidgetType.CA_CUMULE);
            break;
          case WidgetType.PLANNING:
            // Le widget Planning charge ses propres données via facades existantes
            break;
          case WidgetType.EVOLUTION_VALEUR:
            // Le widget Evolution charge ses propres séries (endpoint dédié
            // avec params granularity/dimension/dates).
            break;
          case WidgetType.NC_STATS:
          case WidgetType.NC_CLOSURE_METRICS:
          case WidgetType.NC_SUPPLIER_COMPLIANCE:
            // Widgets qualité self-fetching : chacun gère son timeScale
            // (vl-widget-period-filters) et appelle directement
            // non_conformites/stats|analytics|closure_metrics|supplier_compliance.
            break;
          case WidgetType.LIVE_PRODUCTION:
            // Self-fetching : LiveProductionService gère son polling REST 5s
            // via subscriberCount partagé entre widget et fenêtre détachée.
            break;
          case WidgetType.CERTIFICAT_BIO_ECHEANCE:
            // Self-fetching : charge les certificats bio via /certificat_bio/echeances.
            break;
          case WidgetType.COUVERTURE_COMMANDES:
            // Self-fetching : endpoint paramétrable /widget/couverture-commandes
            // (horizon réglable). Le widget gère son propre fetch + refreshTick.
            break;
          default:
            this.facade.loadById(this.widget()?.type);
            break;
        }
      }
    });
  }

  protected readonly type = TypeControle;
}
